var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataChartsChart = function SvgDataChartsChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3v15c0 1.093.907 2 2 2h15v-2H6V3H4Zm16.293 2.293L16 9.586l-3-3-5.707 5.707 1.414 1.414L13 9.414l3 3 5.707-5.707-1.414-1.414Z"
  })));
};
export default SvgDataChartsChart;